var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXmarkSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70404 1.83279C10.0945 1.44235 10.0945 0.808273 9.70404 0.417831C9.3136 0.0273895 8.67952 0.0273895 8.28908 0.417831L5 3.71004L1.70779 0.420955C1.31735 0.030513 0.683273 0.030513 0.292831 0.420955C-0.0976105 0.811397 -0.0976105 1.44547 0.292831 1.83592L3.58504 5.125L0.295955 8.41721C-0.094487 8.80765 -0.094487 9.44173 0.295955 9.83217C0.686397 10.2226 1.32047 10.2226 1.71092 9.83217L5 6.53996L8.29221 9.82904C8.68265 10.2195 9.31673 10.2195 9.70717 9.82904C10.0976 9.4386 10.0976 8.80452 9.70717 8.41408L6.41496 5.125L9.70404 1.83279Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmarkSolid);
export default __webpack_public_path__ + "static/media/xmark-solid.c4c0e7e8d7710eef3fc7920ff6f5af09.svg";
export { ForwardRef as ReactComponent };